import { getCookie, getLang, setCookie } from '../../common/Utils';
import Modal from '../modal/Modal';
import { ncBannerOptions } from '../../interface/ICommonbanner';
import { l10nAllLang } from '../../common/L10n';
import { replaceLocale, setStartEndDateTime } from '../utils/Utils';


/**
 * @category Commonbanner
 * @description
 * 이미지 배너
 * 메인페이지에서만 노출
 * 그만보기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 */


class ImageLayer {
  isCookieApply: boolean;

  constructor(_isMain: boolean = false, _isLauncher: boolean = false, _data: ncBannerOptions, useCookie: boolean) {
    this.isCookieApply = useCookie;

    let thisIsCookieApply = this.isCookieApply && getCookie(_data.imageBanner.Cookie);

    if (!_isMain || !_data.imageBanner.show || thisIsCookieApply) {
      return;
    }

    if (_isLauncher && !_data.movieBanner.LauncherShow) {
      return;
    }

    setStartEndDateTime(_data, _data.imageBanner, this.templateImage.bind(this));
  }

  templateImage(_data: ncBannerOptions) {
    let customClassName = (_data.imageBanner.OrientationVertical) ? 'imgBannerVertical' : '';

    let lang = getLang() || 'en';
    let l10n = l10nAllLang[lang].commonBanner;
    const { Link, LinkNewWindow, MobileBG, PcBG, EnableScroll=false } = _data.imageBanner;

    let ncBannerModalImage = new Modal({

      id: 'NC-banner-modal',
      className: customClassName,
      contents: `
      <div class="nc-banner-modal-mobile">
        ${Link ? `<a href="${replaceLocale(Link)}" target="${LinkNewWindow ? '_blank' : '_self'}">` : ''}
          <img src="${MobileBG}">
        ${Link ? `</a>` : ''}
      </div>
      <div class="nc-banner-modal-pc">
        ${Link ? `<a href="${replaceLocale(Link)}" target="${LinkNewWindow ? '_blank' : '_self'}">` : ''}
          <img src="${PcBG}">
        ${Link ? `</a>` : ''}
      </div>
      `,
      enableScroll: EnableScroll,
      primaryBtnText: l10n.stop_watching,
      cancelBtnText: l10n.close,
      willOpen: () => { },
      didClose: (_result: boolean) => this.addEvents(_result, _data)
    });

    ncBannerModalImage.open();
  }

  addEvents(_result: boolean, _data: ncBannerOptions) {
    if (_result) {
      if (this.isCookieApply) {
        setCookie('ncBanner' + _data.imageBanner.Cookie, "true", 100, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
        setCookie('ncBanner' + _data.imageBanner.Cookie, "true", 100, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
        setCookie('ncBanner' + _data.imageBanner.Cookie, "true", 100, '.plaync.com'); // 쿠키 사용
      }
    }
  }

}
export default ImageLayer;
